import { appColors, CareerCategory, CareerPath } from '@backrs_ui/common-ui';

import { Box, Typography, SxProps, Theme } from '@mui/material';

type CareerPathColumnGroupProps = Readonly<{
  index: number;
  careerPaths: CareerPath[];
  category: CareerCategory;
  setCurrentDialogCareerPath: (path: CareerPath) => void;
}>;

export const CareerPathColumnGroup = ({
  index,
  careerPaths,
  category,
  setCurrentDialogCareerPath,
}: CareerPathColumnGroupProps) => {
  const handleClick = (path: CareerPath) => {
    setCurrentDialogCareerPath(path);
  };

  return (
    <Box key={index} sx={columnContainerStyle}>
      <Box sx={headerStyle}>
        <Typography sx={categoryNameSx}>{category.name}</Typography>
      </Box>
      <Box pl={2}>
        {careerPaths.map((path, index) => {
          return path.career_category_id === category.id ? (
            <Box sx={lineItemContainerStyle} key={index} onClick={() => handleClick(path)}>
              <Typography variant="body1" sx={pathNameStyle}>
                {path.name}
              </Typography>
            </Box>
          ) : null;
        })}
      </Box>
    </Box>
  );
};

const lineItemContainerStyle: SxProps<Theme> = {
  display: 'flex',
  cursor: 'pointer',
  pb: 0.25,
  '@media (max-height: 768px)': {
    pb: 0.1,
  },
  color: appColors.neutral.black,
  '&:hover': {
    color: `${appColors.neutral.black}60`,
  },
};

const pathNameStyle: SxProps<Theme> = {
  fontSize: 12,
  fontWeight: 500,
};

const columnContainerStyle: SxProps<Theme> = {
  minWidth: '220px',
  borderRadius: 2,
  mr: 2,
  backgroundColor: `${appColors.color.blue9}90`,
  height: 'fit-content',
  mb: 2,
  '@media (max-height: 768px)': {
    mb: 0.5,
  },
  pb: 1,
} as const;

const headerStyle: SxProps<Theme> = {
  lineHeight: '20px',
  backgroundColor: appColors.color.blue1,
  color: appColors.neutral.white,
  pl: 2,
  py: 0.5,
  mb: 0.5,
  borderRadius: 4,
  boxSizing: 'border-box',
  '& .MuiChip-label': {
    padding: 0,
  },
};

const categoryNameSx: SxProps<Theme> = {
  fontSize: 13,
  fontWeight: 700,
  '@media (max-height: 768px)': {
    fontSize: 12,
  },
};
